import {atom} from 'jotai';
import {OrderId, TrTxId} from './TrTx';

const createIdsRegistry = <Id extends string | number>() => {
    const list$ = atom(new Set<Id>());

    return atom(
        get => {
            const list = get(list$);
            return {
                has: (trtId: Id) => list.has(trtId),
            };
        },
        (get, set, trtId: Id) => {
            const list = get(list$);
            const shouldUpdate = !list.has(trtId);
            if (shouldUpdate) {
                const updatedList = new Set(list).add(trtId);
                set(list$, updatedList);
            }
            return () => {
                if (shouldUpdate) {
                    set(list$, list);
                }
            };
        }
    );
};

export const canceledTrTxIds$ = createIdsRegistry<TrTxId>();

export const submittedReceiveTrTxIds$ = createIdsRegistry<OrderId>();
